import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
jQueryBridget('flickity', Flickity, $);

$('.js-carousel').each((index, carousel) => {
  const $carousel = $(carousel);

  $carousel.flickity({
    arrowShape: `m1.053 52.605 33.579 33.579c1.474 1.474 3.789 1.474 5.158 0 1.474-1.474 1.474-3.789 0-5.158L12.421 53.658h83.895c2 0 3.684-1.684 3.684-3.684s-1.684-3.684-3.684-3.684h-83.79l27.368-27.368c1.474-1.474 1.474-3.789 0-5.158-.737-.737-1.684-1.053-2.632-1.053s-1.895.316-2.632 1.053L1.053 47.342C.316 48.079 0 48.921 0 49.974s.421 1.894 1.053 2.631z`,
    contain: true,
    draggable: true,
    pageDots: true,
    prevNextButtons: true,
    wrapAround: true,
  });
});
